import { render, staticRenderFns } from "./VerificationSummary.vue?vue&type=template&id=53fd74b2&scoped=true&"
import script from "./VerificationSummary.vue?vue&type=script&lang=js&"
export * from "./VerificationSummary.vue?vue&type=script&lang=js&"
import style0 from "./VerificationSummary.vue?vue&type=style&index=0&id=53fd74b2&scoped=true&lang=css&"
import style1 from "./VerificationSummary.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53fd74b2",
  null
  
)

export default component.exports